
import Header from "../Components/Header"

import Footer from "../Components/Footer";
import CommonLanding from "../Components/CommonLanding";
import "swiper/css";
import "swiper/css/navigation";


export default function CorporateLanding() {
  return (
    <>
    <CommonLanding
      title="Corporate Sailing Regattas"
      subtitle="Build stronger teams on water"
      heading="Teamwork Meets Adventure"
      text="Boost collaboration, leadership, and strategy through sailing experiences."
      image="https://images.unsplash.com/photo-1500375592092-40eb2168fd21"
      ctaText="Plan Event"
      schema={{
        "@context": "https://schema.org/",
        "@type": "Service",
        "serviceType": "Corporate Team Building Sailing"
      }}
      features={[
        { title: "Expert Trainers", desc: "Guided sailing." },
        { title: "Team Competition", desc: "Real races." },
        { title: "Safe Setup", desc: "Structured events." }
      ]}
    />
      <Header />

      <section className="ib-bday-wrapper">
        <div className="ib-bday-hero">
          <h1 className="ib-bday-title">
            Corporate Sailing Regattas
          </h1>
          <p className="ib-bday-subtitle">
            Build stronger teams on the water.
          </p>
        </div>

        <div className="ib-bday-section">
          <h2 className="ib-bday-heading">
            Teamwork Meets Adventure
          </h2>
          <p className="ib-bday-text">
            Sailing requires real-time collaboration, leadership, and strategy.
          </p>
        </div>

        <div className="ib-bday-feature-grid">
          <div className="ib-bday-card">
            <h3>Expert Guidance</h3>
            <p>Professional sailing instructors.</p>
          </div>

          <div className="ib-bday-card">
            <h3>Competitive Fun</h3>
            <p>Team-based racing challenges.</p>
          </div>

          <div className="ib-bday-card">
            <h3>Safe Experience</h3>
            <p>Structured and secure activities.</p>
          </div>
        </div>

        <div className="ib-bday-cta">
          <a href="/contact" className="ib-bday-btn">
            Plan Event
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
}
